import {store} from 'react-easy-state';
import firebase from '../../firebase';
import alert from '../AlertStore';


const sms_data  = store({
    sdate : undefined, //start 00:00
    edate : undefined, //end  23:59
    isLoading : false,
    data  : [],

    onDateChange(date){
        var d = new Date(date);
        d.setHours(0,0,0,0);
        if(sms_data.sdate===d){
            return;//because its already fetched
        }
        sms_data.sdate = new Date(d);
        d.setHours(23);
        d.setMinutes(59);
        sms_data.edate = new Date(d);
        sms_data.getHistData();
    },

    getHistData(){
        sms_data.isLoading =true;
        sms_data.data = [];
        console.log(sms_data.sdate,sms_data.edate);
        firebase.firestore().collection('SmsLog')
                            .where('date','>=',new Date(sms_data.sdate))
                            .where('date','<=',new Date(sms_data.edate))
                            .onSnapshot(function(snap){
            var temp = [];
            snap.forEach(function(doc){
                temp.push(doc.data());
            })
            sms_data.isLoading = false;
            sms_data.data      = temp;
            console.log(temp);
        },function(err){
            console.error(err);
            alert.showMessage(err.message,"danger");
            sms_data.isLoading = false;
            sms_data.data      = [];

        })
    },
})




export default sms_data;